import { render, staticRenderFns } from "./Certificates.vue?vue&type=template&id=62aa2b24&scoped=true&"
import script from "./Certificates.vue?vue&type=script&lang=js&"
export * from "./Certificates.vue?vue&type=script&lang=js&"
import style0 from "./Certificates.vue?vue&type=style&index=0&id=62aa2b24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aa2b24",
  null
  
)

export default component.exports